/* The mockup's `.card.table-wrap` + `.table`: 13px text, 48px rows, hairlines between them. */
.wrap {
  overflow-x: auto;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.table {
  inline-size: 100%;
  border-collapse: collapse;
  font-size: var(--font-size-13);
}

.table th {
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  color: var(--text-subtle);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  text-align: start;
  white-space: nowrap;
}

.table td {
  block-size: 48px;
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--border);
  vertical-align: middle;
}

.table tbody tr:last-child td {
  border-block-end: 0;
}

.table tbody tr:hover {
  background: var(--surface-sunken);
}

.actionsHead,
.actions {
  text-align: end;
  white-space: nowrap;
}

.name {
  color: var(--text);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
}

.name:hover {
  text-decoration: underline;
}

.name:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.tags,
.date {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.date {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* The actions column has no visible heading (the mockup's `.sr-only`), but keeps its name. */
.srOnly {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
